<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-25 14:57:58
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 10:46:57
 * @FilePath: /privacy-web/src/components/Base/BaseTitle.vue
-->
<template>
  <div class="base-title" :class="{ 'base-title-mobile': isMobile }">{{ title }}</div>
</template>
<script>
export default {
  name: "BaseTitle",
  props: {
    title: {
      type: String,
      default: () => "贝壳隐私保护理念",
    },
  },
};
</script>
<style lang="scss" scoped>
.base-title {
  font-size: calc($multiple * 24px);
  font-family: PingFangTC-Medium, PingFangTC;
  font-weight: 500;
  color: #000;
  height: calc($multiple * 33px);
  line-height: calc($multiple * 33px);
  letter-spacing: 3px;
  position: relative;
  width: auto;
}
.base-title::after {
  content: "";
  width: 140%;
  height: calc($multiple * 18px);
  background: #0b70ff;
  border-radius: 1px;
  opacity: 0.1;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc($multiple * -3px);
}
.base-title-mobile {
  font-size: 0.82rem;
  font-family: PingFangTC-Medium, PingFangTC;
  font-weight: 500;
  color: #000000;
  line-height: 1.13rem;
  height: 1.13rem;
  &::after {
    height: 0.51rem;
    border-radius: 0.05rem;
  }
}
</style>
